import { useEffect, useState } from "react";
import { useGetUsersQuery } from "../Admin/adminApiSlice";
import { useCreateGroupMutation } from "./groupApislice";

import useAuth from "../../hooks/useAuth";
import { useMyContext } from "../../MyContext";
import { useNavigate } from "react-router-dom";
export default function CreateGroup() {
  const [groupName, setGroupName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const navigate = useNavigate();
  const { setToast } = useMyContext();
  const { username } = useAuth();

  const {
    data: usersData = [],
    isLoading: isUserLoading,
    isError: isUserError,
    error: userError,
  } = useGetUsersQuery();

  const [
    createGroup,
    {
      data: createGroupData,
      isLoading: isCreateGroupLoading,
      isError: isCreateGroupError,
      isSuccess: isCreateGroupSuccess,
      error: createGroupError,
    },
  ] = useCreateGroupMutation();

  const filteredUsers = usersData.filter((user) =>
    user.username.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleUser = (username) => {
    setSelectedUsers((prev) =>
      prev.includes(username)
        ? prev.filter((name) => name !== username)
        : [...prev, username]
    );
  };

  const handleCreateGroup = async () => {
    if (!groupName) {
      setToast({ message: "Group Name is required", status: "error" });
      return;
    }
    const newGroup = {
      createdBy: username,
      groupName: groupName.trim(),
      members: selectedUsers,
    };
    createGroup(newGroup);
  };
  useEffect(() => {
    if (isCreateGroupError && createGroupError) {
      const errorMessage =
        createGroupError?.data?.message ||
        createGroupError?.data?.error ||
        "an error occured while creating the group";
      console.error(errorMessage);
      setToast({ message: errorMessage, status: "error" });
    }
    if (isCreateGroupSuccess && createGroupData) {
      console.log(createGroupData?.message);
      const successMessage =
        createGroupData?.message || "Group created successfully";
      setToast({ message: successMessage, status: "success" });
      navigate("/home/dash/group");
    }
  }, [isCreateGroupSuccess, isCreateGroupError]);

  return (
    <main className="overflow-hidden flex flex-col w-full h-[92vh]">
      <section className="flex items-center justify-between px-2 border border-b-0 border-gray-300 h-[6%] font-medium w-full">
        Add a new group
        <div className="flex justify-end gap-4 text-sm">
          <button
            onClick={() => navigate("/home/dash/group")}
            className="border border-gray-400 rounded px-2 py-1 tracking-wide"
          >
            Cancel
          </button>
          <button
            onClick={handleCreateGroup}
            className="border border-gray-400 rounded px-2 py-1 bg-blue-950 text-white tracking-wide"
          >
            {isCreateGroupLoading ? "Creating..." : "Create"}
          </button>
        </div>
      </section>
      <section className="flex flex-col items-start justify-start border border-b-0 border-gray-300 h-[94%] w-full gap-2">
        {/* group name */}
        <div className="flex flex-col w-full md:w-1/2 items-start justify-start gap-1 p-2">
          <label htmlFor="groupName" className="font-medium text-sm">
            Group Name
          </label>
          <input
            type="text"
            name="groupName"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            className="border rounded w-full h-auto p-[0.2rem] focus:outline-0"
          />
        </div>
        <hr className="border border-x-0 border-t border-b-0 w-full" />
        {/* users */}
        <div className="w-full flex flex-col items-start justify-start gap-2 h-auto px-2 pb-2">
          {/* search user */}
          <div className="flex flex-col w-full md:w-1/2 items-start justify-start gap-1">
            <label htmlFor="searchTerm" className="font-medium text-sm">
              Search User
            </label>
            <input
              type="text"
              name="searchTerm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="border rounded w-full h-auto p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="w-full items-start justify-start gap-2 grid grid-cols-1 md:grid-cols-4 h-[28rem] md:h-[36rem] overflow-hidden overflow-y-auto">
            {isUserLoading ? "fetching user..." : null}
            {Array.isArray(filteredUsers) && filteredUsers.length
              ? filteredUsers.map((user, index) => (
                  <label
                    key={index}
                    className="flex items-center text-gray-800"
                  >
                    <input
                      type="checkbox"
                      checked={selectedUsers.includes(user.username)}
                      onChange={() => toggleUser(user.username)}
                      className="mr-[6px] checkbox-input"
                    />
                    <span className="w-[80%] truncate">{user.username}</span>
                  </label>
                ))
              : null}
            {isUserError && userError ? (
              <p className="text-red-500 font-semibold">
                {userError?.data?.message || "error fetching users"}
              </p>
            ) : null}
          </div>
        </div>
      </section>
    </main>
  );
}
